import React, { useEffect, useState } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { Grid, Typography } from "@mui/material";
import Loading from "../common/Loading";
import { useReservationAdminAPI } from "../../service/useReservationAdminAPI";
import { useTranslation } from "react-i18next";
import TimeCalendar from "./TimeCalendar";
import AppSnackbar from "../../common/AppSnackbar";

const PickUpDeliverySchedules = () => {
  const { t } = useTranslation();
  const { getPickUpDeliverSchedules, addToTimeSchedule } =
    useReservationAdminAPI();
  const [schedules, setSchedules] = useState([
    {
      id: -1,
      startPeriod: "2025-01-01",
      endPeriod: "9999-01-01",
      checkScheduleDays: [],
    },
  ]);
  const [isLoading, setIsLoading] = useState(true);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [severity, setSeverity] = useState("error");

  function getDeliverySchedules() {
    getPickUpDeliverSchedules()
      .then((data) => {
        if (data.length > 0) {
          setSchedules(data);
        }
      })
      .catch((error) => {
        setSnackbarMessage(t("error_fetching_schedules"));
        setOpenSnackbar(true);
      })
      .finally(() => setIsLoading(false));
  }

  useEffect(() => {
    getDeliverySchedules();
  }, [t]);

  const onToggle = (dayTimeScheduleInput) => {
    addToTimeSchedule(dayTimeScheduleInput)
      .then(() => {
        setSeverity("success");
        setSnackbarMessage(t("success"));
        setOpenSnackbar(true);
      })
      .catch(() => {
        setSeverity("error");
        setSnackbarMessage(t("error_fetching_schedules"));
        setOpenSnackbar(true);
      })
      .finally(() => getDeliverySchedules());
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <Grid container spacing={2} data-testid="pickup-delivery-schedules-container">
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            sx={{ mb: 3 }}
            wrap="nowrap"
          >
            <Grid item>
              <Typography variant="h4" component="h2">
                {t("checkInCheckOut")}
              </Typography>
            </Grid>
          </Grid>
          <TimeCalendar scheduleDays={schedules} onToggle={onToggle} />
        </Grid>
      )}
      <AppSnackbar
        openSnackbar={openSnackbar}
        snackbarMessage={snackbarMessage}
        setOpenSnackbar={setOpenSnackbar}
        severity={severity}
      />
    </>
  );
};

export default withAuthenticationRequired(PickUpDeliverySchedules, {
  onRedirecting: () => <Loading />,
  returnTo: "/login",
});
